import nxModule from 'nxModule';
import templateUrl from './system-health-check.template.html';

import {healthCheckPhase} from 'constants/healthCheckPhase';

class SystemHealthCheck {
  constructor(http, authentication) {
    this.checks = null;
    this.hideOk = true;
    this.healthCheckPhase = healthCheckPhase.HEALTH_CHECK;
    this.refreshButtonName = 'Refetch';

    this.http = http;
    this.authentication = authentication;
  }

  refetchHealthChecks() {
    this.http.get(`/system/health-details?includeStatement=true&phases=${this.healthCheckPhase}&branchId=${this.authentication.context.branchId}`)
      .success(data => this.checks = data);
  }

}

nxModule.component('systemHealthCheck', {
  templateUrl,
  controller: SystemHealthCheck
});